import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import { translate } from 'react-i18next';

import Navigation from '../../components/Navigation';
import GoogleTagManager from '../../components/GoogleTagManager';
import { version } from '../../util/constants';
import Footer from '../Footer';
import './app.scss';

import CenteredImage from '../CenteredImage';

class App extends Component {

  componentDidMount() {
    // it is fine to load configurations here according to sources like https://daveceddia.com/where-fetch-data-redux/
    this.props.loadInitialState();
    this.props.loadConfiguration();
  }

  render() {
    const isLoading = (
      this.props.fetchingReservation ||
      this.props.cancellingReservation ||
      this.props.currentlyIdentifying ||
      this.props.currentlyRegistering ||
      this.props.pathLoading ||
      this.props.rootLoading ||
      this.props.requestingTimeSlots ||
      this.props.storingReservation ||
      this.props.loadingLocalizations ||
      this.props.historyInitialLoading ||
      this.props.historyLoading ||
      this.props.loadingStaticData ||
      this.props.bankRedirectingInProcess ||
      this.props.loadingConfiguration
    );
    const { googleAnalyticsTrackingId, googleTagManagerId, t } = this.props;
    const loadingClass = isLoading ? 'loading' : '';
    const showAlert = this.props.sessionTimeout;

    document.title = t('title');
    const versionStr = `${t('footerVersion')}: ${version}`;
    return (
      <div className="app">
        <div className={`app-loader ${loadingClass}`}>
          <CenteredImage containerHeight="150px" containerWidth="300px" src={this.props.organizationLogoUrl} className="animated infinite pulse position-loading-indicator" />
        </div>
        { showAlert && !this.props.userIdentified &&
          <Alert bsStyle="warning" onDismiss={this.props.resetAppState}>
            <strong>{t('sessionExpiredTitle')}</strong> {t('sessionExpiredText')}
          </Alert>
        }
        <Navigation />
        {this.props.children}
        <Footer version={versionStr} provider={t('footerProvider')} />
        { googleAnalyticsTrackingId.length > 0 && googleTagManagerId.length > 0 &&
          <GoogleTagManager googleAnalyticsTrackingId={googleAnalyticsTrackingId} googleTagManagerId={googleTagManagerId} />
        }
      </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.node.isRequired,
  fetchingReservation: PropTypes.bool,
  cancellingReservation: PropTypes.bool,
  currentlyIdentifying: PropTypes.bool,
  currentlyRegistering: PropTypes.bool,
  userIdentified: PropTypes.bool,
  rootLoading: PropTypes.bool,
  pathLoading: PropTypes.bool,
  requestingTimeSlots: PropTypes.bool,
  storingReservation: PropTypes.bool,
  sessionTimeout: PropTypes.bool,
  resetAppState: PropTypes.func.isRequired,
  organizationLogoUrl: PropTypes.string,
  loadConfiguration: PropTypes.func.isRequired,
  loadingStaticData: PropTypes.bool.isRequired,
  bankRedirectingInProcess: PropTypes.bool.isRequired,
  loadingLocalizations: PropTypes.bool.isRequired,
  loadingConfiguration: PropTypes.bool.isRequired,
  googleAnalyticsTrackingId: PropTypes.string,
  googleTagManagerId: PropTypes.string,
  historyInitialLoading: PropTypes.bool.isRequired,
  historyLoading: PropTypes.bool.isRequired,
  loadInitialState: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

App.defaultProps = {
  fetchingReservation: false,
  cancellingReservation: false,
  currentlyIdentifying: false,
  currentlyRegistering: false,
  userIdentified: false,
  rootLoading: false,
  pathLoading: false,
  historyPreviousLoading: false,
  requestingTimeSlots: false,
  storingReservation: false,
  sessionTimeout: false,
  organizationLogoUrl: '',
  loadingLocalizations: true,
  googleAnalyticsTrackingId: '',
  googleTagManagerId: ''
};

export default translate(['common'])(App);



// WEBPACK FOOTER //
// ./src/components/App/App.jsx